import { render, staticRenderFns } from "./BuildingEditDetailsTab.vue?vue&type=template&id=e2e6bc98"
import script from "./BuildingEditDetailsTab.vue?vue&type=script&lang=ts"
export * from "./BuildingEditDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports